import styled from 'styled-components'
import { omniaTheme } from '../../theme/omniaTheme'

/**
 * Omnia footer is intentionally minimal — no purple bar like Vimova.
 * The brand calls for a thin hairline divider at the bottom + a small
 * uppercase page-number label, in keeping with the magazine-clean
 * Sequel Sans / Roboto Condensed aesthetic.
 */
export const FooterBar = styled.div`
  height: 14mm;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14mm 8mm 14mm;
  background: ${omniaTheme.colors.pageBg};
  box-sizing: border-box;

  @media print {
    height: 14mm !important;
    padding: 0 14mm 8mm 14mm !important;
    background: ${omniaTheme.colors.pageBg} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const FooterText = styled.span`
  color: ${omniaTheme.colors.textMuted};
  font-family: ${omniaTheme.fonts.label};
  font-size: 8px;
  font-weight: ${omniaTheme.fontWeights.light};
  letter-spacing: ${omniaTheme.letterSpacing.wide};
  text-transform: uppercase;

  @media print {
    color: ${omniaTheme.colors.textMuted} !important;
    font-size: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const FooterPageNumber = styled.span`
  color: ${omniaTheme.colors.textLabel};
  font-family: ${omniaTheme.fonts.label};
  font-size: 9px;
  font-weight: ${omniaTheme.fontWeights.light};
  letter-spacing: ${omniaTheme.letterSpacing.wide};

  @media print {
    color: ${omniaTheme.colors.textLabel} !important;
    font-size: 9px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
